import React,{useEffect} from 'react';
import exterior1 from '../../images/exterior converted/exterior1.jpg';
import exteriorLift from '../../images/exterior converted/lift.JPG';
import exteriorExt from '../../images/exterior converted/ext.JPG';
import exteriorExt2 from '../../images/exterior converted/ext2.JPG';
import exteriorOut from '../../images/exterior converted/out.JPG';
import economic2 from '../../images/economic room/economic2.jpg';
import exterior2 from '../../images/exterior converted/exterior2.jpg';
import exterior3 from '../../images/exterior converted/exterior3.jpg';
import exterior4 from '../../images/exterior converted/exterior4.jpg';
import exterior5 from '../../images/exterior converted/exterior5.jpg';
import exterior6 from '../../images/exterior converted/exterior6.jpg';
import exterior7 from '../../images/exterior converted/exterior7.jpg';
import exterior8 from '../../images/exterior converted/exterior8.jpg';
import exterior9 from '../../images/exterior converted/exterior9.jpg';
import exterior10 from '../../images/exterior converted/exterior10.jpg';
import classic2 from '../../images/classic rooms/classic2.jpg';
import comfort1 from '../../images/comfort room/comfort1.jpg';
// import { HashLink as Link } from 'react-router-hash-link';
import SimpleReactLightbox from 'simple-react-lightbox'
import Lightbox from 'react-image-lightbox';
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import { SRLWrapper } from "simple-react-lightbox";

import 'react-image-lightbox/style.css';

import './Gallery.css'
import { Link } from 'react-router-dom';

function Galleryimg() {
    const photos =[
       {
           tof: exteriorLift,
           url: `${exteriorLift}`,
           alt: 'Lift'
       },{
        tof: exterior2,
        url: `${exterior2}`,
        alt: 'Reception'
       },{
        tof: exteriorExt,
        url: `${exteriorExt}`,
        alt: 'Entrance'
    },{
        tof: exteriorOut,
        url: `${exteriorOut}`,
        alt: 'Out View'
    },{
        tof: exteriorExt2,
        url: `${exteriorExt2}`,
        alt: 'Main Entrance'
    },{
        tof: exterior6,
        url: `${exterior6}`,
        alt: 'Reception '
    },{
        tof: exterior7,
        url: `${exterior7}`,
        alt: 'Reception '
    },{
        tof: exterior8,
        url: `${exterior8}`,
        alt: 'Corridor'
    },{
        tof: exterior9,
        url: `${exterior9}`,
        alt: 'Waiting Space'
    },{
        tof: economic2,
        url: `${economic2}`,
        alt: 'Economic room '
    },
    {
        tof: classic2,
        url: `${classic2}`,
        alt: 'Classic room '
    },
    {
        tof: comfort1,
        url: `${comfort1}`,
        alt: 'Comfort room '
    }
    ]

    useEffect(() => {
        window.scroll(0,0)
        // Aos.init({duration:2000});
      }, []);

    return (
        <div>
        <h2 className='title-gal'>Photo Gallery</h2>
            
            <SimpleReactLightbox>
                <SRLWrapper>
                    <div className='Gallery'>
                            { photos.map((photo,id)=>{
             return <Link key={id} to={photo.url} className='liaison'>
                        <img src={photo.tof} className='Gallery-images' alt={photo.alt} />
                    </Link>
                   
            })}
                    </div>
                </SRLWrapper>
            </SimpleReactLightbox>
            

      {/* <SimpleReactLightbox>
      <SRLWrapper>
     <div>
       <a href="https://picsum.photos/1024/768?image=2">
         <img src={exterior1} alt="lightbox" />
       </a>
       <a href="https://picsum.photos/1024/768?image=3">
         <img src="https://picsum.photos/200/300?image=3" alt="lightbox1" />
       </a>
       <a href="https://picsum.photos/1024/768?image=4">
         <img src="https://picsum.photos/200/300?image=4" alt="lightbox2" />
       </a>
       <a href="https://picsum.photos/1024/768?image=5">
         <img src="https://picsum.photos/200/300?image=5" alt="lightbox3" />
       </a>
     </div>
   </SRLWrapper>
      </SimpleReactLightbox> */}

     
                
                {/* <Link to='' className='liaison'>
                    <img src={exterior2} alt='exterior2' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior3} alt='exterior3' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior4} alt='exterior4' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior5} alt='exterior5' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior6} alt='exterior6' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior7} alt='exterior7' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior8} alt='exterior8' />
                </Link>
                <Link to='' className='liaison'>
                    <img src={exterior9} alt='exterior9' />
                </Link> */}

                
        </div>
    )
}

export default Galleryimg
